export const sessionConstants = {

    GETSESSION_REQUEST: 'USERS_GETSESSION_REQUEST',
    GETSESSION_SUCCESS: 'USERS_GETSESSION_SUCCESS',
    GETSESSION_FAILURE: 'USERS_GETSESSION_FAILURE',

    GETSESSION_HISTORY_REQUEST: 'USERS_GETSESSION_HISTORY_REQUEST',
    GETSESSION_HISTORY_SUCCESS: 'USERS_GETSESSION_HISTORY_SUCCESS',
    GETSESSION_HISTORY_FAILURE: 'USERS_GETSESSION_HISTORY_FAILURE',

    GETSESSION_CSV_HISTORY_REQUEST: 'USERS_CSV_GETSESSION_HISTORY_REQUEST',
    GETSESSION_CSV_HISTORY_SUCCESS: 'USERS_CSV_GETSESSION_HISTORY_SUCCESS',
    GETSESSION_CSV_HISTORY_FAILURE: 'USERS_CSV_GETSESSION_HISTORY_FAILURE',

    SESSION_STATUS_REQUEST: 'SESSION_STATUS_REQUEST',
    SESSION_STATUS_SUCCESS: 'SESSION_STATUS_SUCCESS',
    SESSION_STATUS_FAILURE: 'SESSION_STATUS_FAILURE',

    SESSION_HISTORY_STATUS_REQUEST: 'SESSION_HISTORY_STATUS_REQUEST',
    SESSION_HISTORY_STATUS_SUCCESS: 'SESSION_HISTORY_STATUS_SUCCESS',
    SESSION_HISTORY_STATUS_FAILURE: 'SESSION_HISTORY_STATUS_FAILURE',

    GETSESSION_FILTERED_SESSION_REQUEST: 'GETSESSION_FILTERED_SESSION_REQUEST',
    GETSESSION_FILTERED_SESSION_SUCCESS: 'GETSESSION_FILTERED_SESSION_SUCCESS',
    GETSESSION_FILTERED_SESSION_FAILURE: 'GETSESSION_FILTERED_SESSION_FAILURE',
    SESSION_NATURE_OF_ISSUE_REQUEST: 'SESSION_NATURE_OF_ISSUE_REQUEST',
    SESSION_NATURE_OF_ISSUE_SUCCESS: 'SESSION_NATURE_OF_ISSUE_REQUEST',
    SESSION_NATURE_OF_ISSUE_FAILURE: 'SESSION_NATURE_OF_ISSUE_REQUEST',

    SESSION_UPDATE_NATURE_OF_ISSUE_REQUEST: 'SESSION_UPDATE_NATURE_OF_ISSUE_REQUEST',
    SESSION_UPDATE_NATURE_OF_ISSUE_SUCCESS: 'SESSION_UPDATE_NATURE_OF_ISSUE_REQUEST',
    SESSION_UPDATE_NATURE_OF_ISSUE_FAILURE: 'SESSION_UPDATE_NATURE_OF_ISSUE_REQUEST'

}



// WEBPACK FOOTER //
// ./src/store/constants/session.constants.js